import { render, staticRenderFns } from "./withdrawImg.vue?vue&type=template&id=531eb169&scoped=true&"
import script from "./withdrawImg.vue?vue&type=script&lang=js&"
export * from "./withdrawImg.vue?vue&type=script&lang=js&"
import style0 from "./withdrawImg.vue?vue&type=style&index=0&id=531eb169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531eb169",
  null
  
)

export default component.exports